import Injection = EECore.Injection;
import documentCentre from "../../templates/documentCentre/documentCentre.html";
import documentCentreNoAuth from "../../templates/documentCentre/documentCentre.noauth.html";
import documentCentreAffiliate from "../../templates/documentCentre/documentCentre.affiliate.html";
import documentCentreFavouriteDocuments from "../../templates/documentCentre/favouriteDocuments.html";
import documentCentreFavouriteDocument from "../../templates/documentCentre/favouriteDocument.html";
import documentCentreFavourites from "../../templates/documentCentre/favourites.html";
import documentCentreFavourite from "../../templates/documentCentre/favourite.html";
import documentCentreQuickSearch from "../../templates/documentCentre/quickSearch.html";
import documentCentreAdvancedSearchBar from "../../templates/documentCentre/advancedSearchBar.html";
import documentSearch from "../../templates/documentCentre/documentSearch.html";
import news from "../../templates/news/news.client.html";
import newsAffiliate from "../../templates/news/news.affiliate.html";
import newsItem from "../../templates/news/newsItem.client.html";
import newsItemAffiliate from "../../templates/news/newsItem.affiliate.html";
import unavailable from "../../templates/unavailable/unavailable.html";
import login from "../../templates/login/login.noauth.html";
import loginind from "../../templates/login/login.noauth.ind.html";
import loginnondispo from "../../templates/login/loginnondispo.html";
import application from "../../templates/application/application.html";
import applicationitem from "../../templates/application/applicationItem.html";
import profileReview from "../../templates/promotion/profileReview.html";
import personalizedAccessCode from "../../templates/promotion/personalizedAccessCode.html";
import electronicFeatures from "../../templates/promotion/electronicFeatures.html";
import instabilityMessagesSingle from "../../templates/instabilityMessages/instabilityMessages_Single.html";
import instabilityMessagesMultiple from "../../templates/instabilityMessages/instabilityMessages_Multiple.html";
import instabilityMessagesMultipleItem from "../../templates/instabilityMessages/instabilityMessages_MultipleItem.html";
import corporateSearch from "../../templates/corporateSearch/corporateSearch.html";
import corporateSearchEmpty from "../../templates/corporateSearch/corporateSearchEmpty.html";
import contractList from "../../templates/corporateSearch/contractList.html";
import contractItem from "../../templates/corporateSearch/contractItem.html";
import contractItemNoLink from "../../templates/corporateSearch/contractItemNoLink.html";
import adsSlideshow from "../../templates/ads/adsSlideshow.html";
import adsSlide from "../../templates/ads/adsSlide.html";
import adsList from "../../templates/ads/adsList.html";
import ads from "../../templates/ads/ads.html";
import upcomingUnavailability from "../../templates/upcomingUnavailability/upcomingUnavailability.html";
import widgetBox from "../../templates/common/widgetBox.html";
import securedMessaging from "../../templates/promotion/securedMessaging.html";

@Injection.injectableClass("WidgetTemplateLoader")
export default class TemplateLoader {

  @Injection.injectableProperty("WidgetTemplateLoader", EECore.Registrations.TEMPLATE_FACTORY)
  private templateFactory: EECore.UI.TemplateFactory;

  constructor(templateFactory: EECore.UI.TemplateFactory) {
    this.templateFactory = templateFactory;
  }

  load(): void {
    const templates = {
      default:
      {
        documentcentre: {
          client: {
            noauth: documentCentreNoAuth,
            default: documentCentre
          },
          advisor: {
            noauth: documentCentreNoAuth,
            default: documentCentre
          },
          employee: {
            noauth: documentCentreNoAuth,
            default: documentCentre
          },
          employee_sal: {
            noauth: documentCentreNoAuth,
            default: documentCentre
          },
          employee_iavm: {
            noauth: documentCentreNoAuth,
            default: documentCentre
          },
          default: documentCentre
        },
        documentcentrefavouritedocuments: {
          default: documentCentreFavouriteDocuments
        },
        documentcentrefavouritedocument: {
          default: documentCentreFavouriteDocument
        },
        documentcentrefavourites: {
          default: documentCentreFavourites
        },
        documentcentrefavourite: {
          default: documentCentreFavourite
        },
        documentcentrequicksearch: {
          default: documentCentreQuickSearch
        },
        documentcentreadvancedsearchbar: {
          default: documentCentreAdvancedSearchBar
        },
        documentsearch: {
          default: documentSearch
        },
        news: {
          default: news
        },
        newsitem: {
          default: newsItem
        },
        login: {
          default: login
        },
        loginind: {
          default: loginind
        },
        loginnondispo: {
          default: loginnondispo
        },
        application: {
          default: application
        },
        applicationitem: {
          default: applicationitem
        },
        profilereview: {
          default: profileReview
        },
        personalizedaccesscode: {
          default: personalizedAccessCode
        },
        electronicfeatures: {
          default: electronicFeatures
        },
        securedmessaging: {
          default: securedMessaging
        },
        instabilitymessagessingle: {
          default: instabilityMessagesSingle
        },
        instabilitymessagesmultiple: {
          default: instabilityMessagesMultiple
        },
        instabilitymessagesmultipleitem: {
          default: instabilityMessagesMultipleItem
        },
        corporatesearch: {
          default: corporateSearch
        },
        corporatesearchempty: {
          default: corporateSearchEmpty
        },
        contractlist: {
          default: contractList
        },
        contractitem: {
          default: contractItem
        },
        contractitemnolink: {
          default: contractItemNoLink
        },
        adsslideshow: {
          default: adsSlideshow
        },
        adsslide: {
          default: adsSlide
        },
        adslist: {
          default: adsList
        },
        ads: {
          default: ads
        },
        widgetbox: {
          default: widgetBox
        },
        unavailable: {
          default: unavailable
        },
        upcomingunavailability: {
          default: upcomingUnavailability
        }
      },
      investia: {
        documentcentre: {
          advisor: {
            default: documentCentreAffiliate
          },
          default: documentCentreAffiliate
        },
        news: {
          default: newsAffiliate
        },
        newsitem: {
          default: newsItemAffiliate
        }
      },
      fundex: {
        documentcentre: {
          advisor: {
            default: documentCentreAffiliate
          },
          default: documentCentreAffiliate
        },
        news: {
          default: newsAffiliate
        },
        newsitem: {
          default: newsItemAffiliate
        }
      }
    };
    this.templateFactory.addTemplate(templates);
  }
}